import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
import { Building, Calendar2, CardText, Cash, Clock, TextParagraph } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import imageCompression from "browser-image-compression";
import Option from "./option";

export default function AbonnementInfos({ codeabonnement }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [compressing, setCompressin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [suspending, setSuspending] = useState(false);
    const [starting, setStarting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [lib, setlib] = useState("");
    const [profile, setprofile] = useState("");
    const [desc, setdesc] = useState("");
    const [duree, setduree] = useState("");
    const [prix, setprix] = useState("");
    const [typeabonnement, settypeabonnement] = useState('');
    const [typeabonnementsList, settypeabonnementsList] = useState([]);
    const [options, setoptions] = useState([]);
    const [option, setoption] = useState('');
    const [nbsite, setnbsite] = useState('');
    const [picture, setPicture] = useState('');
    const [pictureprev, setPictureprev] = useState('/assets/imgs/no-image.png');

    const [unite, setUnite] = useState("");

    const unites = [
        {
            label: "Année (s)",
            value: "years",
        },
        {
            label: "Mois",
            value: "months",
        },
        {
            label: "Jour (s)",
            value: "days",
        },
    ];

    const [datecrea, setDatecrea] = useState("");
    const [etatdef, setetatdef] = useState("");
    const [etat, setEtat] = useState(0);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getTypeabonnementsList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=tabonnement&page=1&limit=10`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        settypeabonnementsList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("serveur erreur", "error");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut erreur", "error");
            }

        }).catch((err) => {
            console.log("Catch error", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(
            `${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions/${codeabonnement}?limit=1&page=1`,
            requestOptions
        ).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];
                        let dureee = body?.duree.split(" ");

                        setprix(body?.prix !== null ? Number.parseInt(body?.prix) : "");
                        setnbsite(body?.nbsite !== null ? Number.parseInt(body?.nbsite) : "");

                        setlib(body?.lib !== null ? body?.lib : "");
                        setprofile(body?.prof !== null ? body?.prof : "");
                        setdesc(body?.descr !== null ? body?.descr : "");

                        if (body.options !== null) {
                            // let opts = body?.options.replace("{", "").replace("}", "");
                            // let optssplit = opts.split(",");
                            // console.log("elements split: ", optssplit);
                            const list = [...options];
                            for (let i = 0; i < body?.options.length; i++) {
                                const element = body?.options[i];
                                list.push({ label: element });
                            }
                            setoptions(list);
                        }

                        setduree(body?.duree !== null ? dureee[0] : "");
                        setUnite(body.duree !== null ? {
                            label:
                                dureee[1] === "année(s)"
                                    ? "Année (s)"
                                    : dureee[1] === "mois"
                                        ? "Mois"
                                        : dureee[1] === "jour(s)"
                                            ? "Jour (s)"
                                            : "",
                            value: dureee[1] === "année(s)"
                                ? "years"
                                : dureee[1] === "mois"
                                    ? "months"
                                    : dureee[1] === "jour(s)"
                                        ? "days"
                                        : "",
                        } : "");
                        settypeabonnement(
                            body?.codetabonnement ? { label: body?.libtabonnement, value: body?.codetabonnement, } : ""
                        );
                        setEtat(body?.etat !== null ? body?.etat : 0);
                        setetatdef(body?.etatdef !== null ? body?.etatdef : "");

                        setPictureprev((body?.img !== null) ? body?.img : "/assets/imgs/blank.png");

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(
                            body?.datecrea !== null
                                ? body?.datecrea.slice(0, 16).replace("T", " à ")
                                : ""
                        );

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    const handlepicturechange = (e) => {
        const file = e.target.files[0];
        setPicture(file)
        TransformPicture(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformPicture = async (file) => {
        const reader = new FileReader();

        const options = {
            maxSizeMB: config.app.maxsizefileoption,
            maxWidthOrHeight: 500,
            useWebWorker: true
        };

        if (file) {
            if (file.size > config.app.maxsizefile * 1024) {
                setCompressin(true);
                await imageCompression(file, options).then((img) => {
                    reader.readAsDataURL(img);
                    reader.onloadend = () => {
                        setPictureprev(reader.result);
                    };
                });
                setCompressin(false);
            } else {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setPictureprev(reader.result);
                };
            }

        } else {
            setPictureprev("/assets/imgs/no-image.png");
        }
    };

    const handleAddOption = () => {
        const list = [...options];
        list.push({ label: option });
        setoptions(list);
        setoption('');
    }

    const handleDeleteOption = async (index) => {
        const list = [...options];
        list.splice(index, 1);
        setoptions(list);
    }

    // comportements
    useEffect(() => {
        getTypeabonnementsList();
        getElement();
    }, []);

    const handleDelete = async () => {
        confirmAlert({
            title: textes.fr.deleteabonnementlabel,
            message: textes.fr.deleteabonnementlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: "DELETE",
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: "follow",
                        };

                        // console.log("data send", urlencoded);

                        await fetch(
                            `${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions/${codeabonnement}`,
                            requestOptions
                        ).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.abonnementdeletedlabel);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setDeleting(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editabonnementlabel,
            message: textes.fr.editabonnementlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (lib) urlencoded.append("lib", lib);
                        if (profile) urlencoded.append("prof", profile);
                        if (desc) urlencoded.append("descr", desc);
                        if (prix) urlencoded.append("prix", prix);
                        if (typeabonnement) urlencoded.append("codetabonnement", typeabonnement["value"]);
                        if (duree && unite) urlencoded.append("duree", duree + " " + unite["value"]);
                        if (options.length > 0) urlencoded.append("options", options.map((i) => i["label"]));
                        if (nbsite) urlencoded.append("nbsite", nbsite);
                        if (picture) urlencoded.append("img", pictureprev);
                        urlencoded.append("etatdef", etatdef);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);

                        // console.log("data send", urlencoded)

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions/${codeabonnement}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage(textes.fr.abonnementupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setFetching(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSuspende = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editabonnementlabel,
            message: textes.fr.editabonnementlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setSuspending(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Suspendu");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions/${codeabonnement}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.abonnementupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setSuspending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setSuspending(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setSuspending(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setSuspending(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleStart = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editabonnementlabel,
            message: textes.fr.editabonnementlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setStarting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "1");
                        urlencoded.append("etatdef", "En service");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions/${codeabonnement}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.abonnementupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setStarting(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setStarting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setStarting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setStarting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        {(user?.isFullAction || user?.isAdminAction || user?.isModifierAbonnement) && !editedstate && etat === 2 && (
                                            <button
                                                onClick={() => setEditedstate(true)}
                                                title={textes.fr.editabonnementlabel}
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right"
                                            >
                                                <i className="fa fa-edit mr-1"></i>{" "}
                                                <span>{textes.fr.edit}</span>
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isSupprimerAbonnement) && !editedstate && etat === 2 && (
                                            <button
                                                onClick={handleDelete}
                                                title={textes.fr.deleteabonnementlabel}
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                            >
                                                <i className="fa fa-trash mr-1"></i>{" "}
                                                <span>{textes.fr.delete}</span>{" "}
                                                {deleting && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isActiverAbonnement) && !editedstate && etat === 2 && <button onClick={handleStart}
                                            title="Réactiver l'abonnement"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-arrow-up mr-1"></i> <span>Activer</span>  {starting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isSuspendreAbonnement) && !editedstate && etat === 1 && <button onClick={handleSuspende}
                                            title="Suspendre l'abonnement"
                                            className="btn-shadow ml-3 btn btn-warning btn-sm float-right">
                                            <i className="fa fa-arrow-down mr-1"></i> <span>Suspendre</span>  {suspending && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        <h5 className="m-0 ">
                                            {textes.fr.abonnementinfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form
                                            style={{ width: "100%" }}
                                            className="mb-3"
                                            onSubmit={handleSubmitEdit}
                                        >
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <div className="row">
                                                        {editedstate && <div className="col-md-12 mb-2">
                                                            <label htmlFor="logo" className="form-label">Image illustrative</label>
                                                            <input className="form-control" type="file" id="logo" onChange={handlepicturechange} />
                                                        </div>}
                                                        {compressing && <div className="col-md-12 p-5 mb-3">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="lg"
                                                                role="status"
                                                                aria-hidden="true"
                                                                style={{ display: "block", marginLeft: 'auto', marginRight: 'auto' }}
                                                            />
                                                        </div>}
                                                        {!compressing && <div className="col-md-12 mb-3">
                                                            <img alt="" src={pictureprev} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                        </div>}
                                                        <div className="col-md-12 mb-3">
                                                            {editedstate && <h6 className="mb-2">Ajouter des options</h6>}
                                                            <div className="row">
                                                                {editedstate && <div className="col-md-12 mb-1">
                                                                    <label htmlFor="option" className="mb-1">Option</label>
                                                                    <div className="input-group flex-nowrap">
                                                                        <span className="input-group-text" id="option"><TextParagraph /></span>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder={textes.fr.entervaluelabel}
                                                                            value={option}
                                                                            onChange={(e) =>
                                                                                setoption(e.target.value)
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>}
                                                                {editedstate && <div className="col-md-12 mb-3">
                                                                    <button
                                                                        title={textes.fr.validateaddlabel}
                                                                        className="btn-shadow w-auto btn btn-primary btn-sm float-right"
                                                                        disabled={option ? false : true}
                                                                        onClick={handleAddOption}
                                                                    >
                                                                        <i className="fa fa-plus mr-3"></i> Ajouter
                                                                    </button>
                                                                </div>}
                                                                <div className="col-md-12 mb-3">
                                                                    <h6 className="mb-2">Liste des options de l'abonnement</h6>
                                                                    <div className="table-responsive mb-3">
                                                                        <table className="mb-0 table table-bordered">
                                                                            <thead className="bg-primary">
                                                                                <tr className="bg-primary text-white">
                                                                                    <th className="text-center">#</th>
                                                                                    <th>Option</th>
                                                                                    <th className="text-center">{textes.fr.actionlabel}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {(options.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                                                    <th colSpan={3} className="text-center">Aucune option trouvée</th>
                                                                                </tr>}
                                                                                {
                                                                                    (options.length > 0) && options?.map((item, index) => (
                                                                                        <Option opt={item} position={index} key={index} handledelete={() => handleDeleteOption(index)} />
                                                                                    ))
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-8 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="typeabonnement" className="mb-1">
                                                                {textes.fr.typeabonnementlabel}
                                                            </label>
                                                            <Select
                                                                id="typeabonnement"
                                                                name="typeabonnement"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={typeabonnementsList}
                                                                value={typeabonnement}
                                                                onChange={(selected) => {
                                                                    settypeabonnement(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="lib" className="mb-1">
                                                                Libelle
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="lib"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={lib}
                                                                    onChange={(e) =>
                                                                        setlib(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="profile" className="mb-1">
                                                                Profile
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="profile"
                                                                >
                                                                    <CardText />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={profile}
                                                                    onChange={(e) =>
                                                                        setprofile(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="prix" className="mb-1">
                                                                Prix
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="prix"
                                                                >
                                                                    <Cash />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={prix}
                                                                    onChange={(e) => { setprix(e.target.value) }}
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="duree" className="mb-1">
                                                                {textes.fr.durelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="duree"
                                                                >
                                                                    <Clock />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={duree}
                                                                    onChange={(e) =>
                                                                        setduree(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="unite" className="mb-1">
                                                                Unité
                                                            </label>
                                                            <Select
                                                                id="unite"
                                                                name="unite"
                                                                placeholder="Sélectionner l'unité"
                                                                options={unites}
                                                                value={unite}
                                                                onChange={(selected) => {
                                                                    setUnite(selected);
                                                                }}
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="nbsite" className="mb-1">Nombre de site</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="nbsite"><Building /></span>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    className="form-control"
                                                                    placeholder="Entrez le nombre de site"
                                                                    value={nbsite}
                                                                    onChange={(e) =>
                                                                        setnbsite(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="desc" className="mb-1">
                                                                Description
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="desc"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder={
                                                                        textes.fr.descriptionlabel
                                                                    }
                                                                    value={desc}
                                                                    style={{ height: 154 }}
                                                                    onChange={(e) =>
                                                                        setdesc(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="etat" className="mb-1">Etat</label>
                                                            <div className="input-group flex-nowrap">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    className={`form-control 
                                                                        ${etat === 1 ? "text-white bg-success" :
                                                                            etat === 2 ? "text-white bg-danger" :
                                                                                ""
                                                                        }`}
                                                                    id="etat"
                                                                    value={etatdef}
                                                                    onChange={(e) => setEtat(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                {textes.fr.addeddatelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {editedstate && (
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.editabonnementlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Modifier</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => setEditedstate(false)}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
